module.exports = __webpack_public_path__ + "069732bd9c5c78a9fb117b54bfbc06af.png";